import { cn } from "@/lib/utils";
import { CATEGORY_LABELS, type ExpenseCategory } from "@cold-crew/shared";

// Color mapping per category
const CATEGORY_COLORS: Record<ExpenseCategory, string> = {
  cafe:            "bg-amber-100  text-amber-800  dark:bg-amber-900/30  dark:text-amber-400",
  agua:            "bg-sky-100    text-sky-800    dark:bg-sky-900/30    dark:text-sky-400",
  vainilla:        "bg-yellow-100 text-yellow-800 dark:bg-yellow-900/30 dark:text-yellow-400",
  conservador:     "bg-lime-100   text-lime-800   dark:bg-lime-900/30   dark:text-lime-400",
  etiquetas:       "bg-purple-100 text-purple-800 dark:bg-purple-900/30 dark:text-purple-400",
  botellas:        "bg-teal-100   text-teal-800   dark:bg-teal-900/30   dark:text-teal-400",
  contenido_redes: "bg-pink-100   text-pink-800   dark:bg-pink-900/30   dark:text-pink-400",
  otro:            "bg-slate-100  text-slate-700  dark:bg-slate-800/50  dark:text-slate-400",
};

interface CategoriaBadgeProps {
  categoria:  ExpenseCategory;
  className?: string;
}

export function CategoriaBadge({ categoria, className }: CategoriaBadgeProps) {
  return (
    <span className={cn(
      "inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium",
      CATEGORY_COLORS[categoria],
      className
    )}>
      {CATEGORY_LABELS[categoria]}
    </span>
  );
}
